<template>
  <svg
    class="ping"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
  >
    <!-- <circle cx="50" cy="50" r="20" fill="#42b983" /> -->
    <circle cx="4" cy="4" r="2" fill="url(#paint0_linear_776_47)" />
    <defs>
      <linearGradient
        id="paint0_linear_776_47"
        x1="-4"
        y1="4"
        x2="4"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5E00" />
        <stop offset="0.541068" stop-color="#F54562" />
        <stop offset="1" stop-color="#C32DE1" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({})
</script>
<style scoped>
.ping circle {
  animation: ping 1s ease-out infinite;
  transform-origin: center;
}

@keyframes ping {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
